export const NUMBER_REG_EXP_PATTERN = /^[-+]?(\d{1,20}?([,.]\d{0,20})?)?$/
export const ONLY_INTEGER_PATTERN = /^[0-9\b]+$/
